module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dialogTitle":"Edit %{eventsContestantName}","eventsContestantsActionsEditOneSuccess":"%{eventsContestantName} was successfully updated in the database"},"no":{"dialogTitle":"Rediger %{eventsContestantName}","eventsContestantsActionsEditOneSuccess":"%{eventsContestantName} ble redigert i databasen"}}')
  delete Component.options._Ctor
}
